import type { IVisitaRepository } from '@/domain/repositories/IVisitaRepository';
import type { UpdateVisitaDTO } from '@/application/dto/visitas/UpdateVisita';

export class UpdateVisitaFechaUseCase {
  constructor(private readonly repository: IVisitaRepository) {}

  execute(id: string, data: UpdateVisitaDTO) {
    return this.repository.updateFecha(id, data);
  }
}
